// extracted by mini-css-extract-plugin
export default {"calendarBodyWrapper":"calendarBody_calendarBodyWrapper__114Ej","otherMonthDate":"calendarBody_otherMonthDate__bj9kM","thisMonthDate":"calendarBody_thisMonthDate__hseEW"};